// extracted by mini-css-extract-plugin
export default {"about":"About_about__yUZyc","aboutTitle":"About_aboutTitle__p+AZT","aboutDesc":"About_aboutDesc__okaH8","aboutBlock":"About_aboutBlock__E2lgm","aboutLink":"About_aboutLink__hpjuy"};